const ifPresent = <T, U>(fn: (t: T) => U) => (t?: T): U | void => ((t) ? fn(t) : undefined);

const plus = (a: number, b: number) => a + b;
const average = (arr: number[]) => arr.reduce(plus, 0) / arr.length;

interface Transformer<T, U> {
  (t: T): U;
}

interface IdentityTransformer<T> extends Transformer<T, T> {
  (t: T): T;
}

function asRecord<T, U>(ts: T[], id: (t: T) => string): Record<string, T>;
function asRecord<T, U>(
  ts: T[], id: (t: T) => string, transformer: Transformer<T, U>,
): Record<string, U>;
function asRecord<T, U>(
  ts: T[], id: (t: T) => string, transformer?: Transformer<T, U>,
): Record<string, T | U> {
  const transform = transformer || ((t: T) => t) as IdentityTransformer<T>;
  return ts.reduce(
    (record: Record<string, T | U>, t: T) => ({
      ...record,
      [id(t)]: transform(t),
    }),
    {} as Record<string, T>,
  );
}

export default {
  asRecord,
  ifPresent,
  plus,
  average,
};
